import axiosInstance from './axiosInstance'

export const getAdhocQuoteById = (quoteId) => {
  return axiosInstance.get(`/adhoc-quotes/${quoteId}`)
}

export const getAdhocQuoteByNumber = (quoteNumber) => {
  return axiosInstance.get(`/adhoc-quotes/by-number/${quoteNumber}`)
}

export const getAdhocQuotes = (page = 1, limit = 50, search = '', orderByKey = 'quoteNo', direction = 'asc') => {
  return axiosInstance.get(`/adhoc-quotes?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const exportAdhocQuotes = ({ search = '', orderByKey = 'quoteNo', direction = 'desc' } = {}) => {
  return axiosInstance.get(`/adhoc-quotes/export?search=${search}&orderByKey=${orderByKey}&direction=${direction}`, { responseType: 'blob' })
}

export const createAdhocQuote = (data) => {
  return axiosInstance.post('/adhoc-quotes', data)
}

export const previewAdhocQuote = (data) => {
  return axiosInstance.post('/adhoc-quotes/preview', data)
}

export const updateAdhocQuote = (quoteId, data) => {
  return axiosInstance.put(`/adhoc-quotes/${quoteId}`, data)
}

export const deleteAdhocQuote = (quoteId) => {
  return axiosInstance.delete(`/adhoc-quotes/${quoteId}`)
}

export const convertAdhocQuoteToProjectById = (quoteId, data) => {
  return axiosInstance.post(`/adhoc-quotes/${quoteId}/convertToProject`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const getAdhocQuoteNoteById = (quoteId, noteId) => {
  return axiosInstance.get(`/adhoc-quotes/${quoteId}/notes/${noteId}`)
}

export const getAdhocQuoteNotes = (quoteId, page = 1, limit = 50, search = '', orderByKey = 'createdAt', direction = 'desc') => {
  return axiosInstance.get(`/adhoc-quotes/${quoteId}/notes?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createAdhocQuoteNote = (quoteId, data) => {
  return axiosInstance.post(`/adhoc-quotes/${quoteId}/notes`, data)
}

export const updateAdhocQuoteNote = (quoteId, noteId, data) => {
  return axiosInstance.put(`/adhoc-quotes/${quoteId}/notes/${noteId}`, data)
}

export const deleteAdhocQuoteNote = (quoteId, noteId) => {
  return axiosInstance.delete(`/adhoc-quotes/${quoteId}/notes/${noteId}`)
}
